import { render } from "./CatalogoRegraDeCalculo.vue?vue&type=template&id=37e6e596&ts=true"
import script from "./CatalogoRegraDeCalculo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogoRegraDeCalculo.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src-next/modulos/folha-de-ponto/regra-de-calculo/catalogo/apresentacao/CatalogoRegraDeCalculo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37e6e596"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37e6e596', __exports__)) {
    api.reload('37e6e596', __exports__)
  }
  
  module.hot.accept("./CatalogoRegraDeCalculo.vue?vue&type=template&id=37e6e596&ts=true", () => {
    api.rerender('37e6e596', render)
  })

}


export default __exports__